/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';

// import {} from 'apollo-cache-inmemory';
// import { createHttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';

import { GRAPHQL_URL } from '../env-config';
import authService from '../providers/auth-service';
import generatedPossibleTypes from '../graphql/possibleTypes.json';

// const fragmentMatcher = new IntrospectionFragmentMatcher({
//   introspectionQueryResultData: fragmentTypes,
// });

const link = new HttpLink({ uri: GRAPHQL_URL, useGETForQueries: false });

const authLink = setContext(async (_, { headers }) => {
  const language = localStorage.getItem('i18nextLng') || 'en';
  let accessToken = null;
  try {
    accessToken = await authService.getAccessToken();
  } catch (e) {
    // TODO : remove existing auth storage
    console.log({ e });
  }

  return {
    headers: {
      ...headers,
      'Accept-Language': language,
      ...(accessToken && {
        authorization: `Bearer ${accessToken}`,
      }),
    },
  };
});

const apolloClient = new ApolloClient({
  link: authLink.concat(link),
  cache: new InMemoryCache({
    possibleTypes: generatedPossibleTypes.possibleTypes,
  }),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'network-only',
      errorPolicy: 'all',
    },
    query: {
      fetchPolicy: 'network-only',
      errorPolicy: 'all',
    },
    mutate: {
      errorPolicy: 'all',
    },
  },
});

export default apolloClient;
